import { render, staticRenderFns } from "./SiteTemplateCard.vue?vue&type=template&id=47006f79"
import script from "./SiteTemplateCard.vue?vue&type=script&lang=js"
export * from "./SiteTemplateCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports